export const quoteContactMethods = {
    email: 100,
    phone: 101
};